export enum Auth {
    LOGIN,
    LOGOUT
}

export enum Role {
    GUEST = -1,
    USER,
    ADMIN,
}

export enum Enum_AuthStatus {
    Login,
    Register,
    Find
}

export enum Enum_RegisterProgress {
    EMAIL,
    ID,
    PW,
    SUCCESS
}